











































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Checkbox from '../common/inputs/Checkbox.vue';
import SearchField from '../common/inputs/SearchField.vue';
import InputField from '../common/inputs/InputField.vue';
import DatePicker from '../common/inputs/DatePicker.vue';
import SearchOption from './SearchOption.vue';
import PillCheckbox from '../common/inputs/PillCheckbox.vue';
import SelectionField from '../common/inputs/SelectionField.vue';
import ExpandPanel from '../common/ExpandPanel.vue';
import { Action, State } from 'vuex-class';
import { PhaseLabels, PhaseKeys } from '@/models/phase';
import { DomainLabels, DomainKeys } from '@/models/domain';
import { VisibilityLabels, VisibilityKeys } from '@/models/visibility';
import { SearchFilters } from '@/store/modules/searchInterfaces';
import Button from '../common/inputs/Button.vue';
import SearchFiltersActions from './SearchFiltersActions.vue';
import SearchSelectSavedFilters from './SearchSelectSavedFilters.vue';
import SearchFiltersRunPeriod from './SearchFiltersRunPeriod.vue';
import { StatusSelect, StatusLabels, StatusKeys, defaultStatusSelects } from '../../models/status';
import { Municipality } from '@/store/modules/commonInterfaces';
import { AuthModule } from '@/store/modules/auth';
import { CommonModule } from '@/store/modules/common';
import { SearchModule } from '@/store/modules/search';
import { OrganisationModule } from '@/store/modules/organisation';

@Component({
  components: {
    SearchField,
    InputField,
    SearchOption,
    ExpandPanel,
    DatePicker,
    Checkbox,
    SelectionField,
    PillCheckbox,
    Button,
    SearchFiltersActions,
    SearchFiltersRunPeriod,
    SearchSelectSavedFilters
  }
})
export default class SearchFiltersComponent extends Vue {
  PhaseLabels = PhaseLabels;
  PhaseKeys = PhaseKeys;
  DomainLabels = DomainLabels;
  DomainKeys = DomainKeys;
  StatusKeys = StatusKeys;
  StatusLabels = StatusLabels;
  VisibilityLabels = VisibilityLabels;
  VisibilityKeys = [VisibilityKeys.MUNICIPALITY, VisibilityKeys.PUBLIC];

  @Prop(Boolean)
  umbrellaProcessSearch!: boolean;

  mounted() {
    CommonModule.loadITSystemsSorted();
    CommonModule.loadMunicipalities();
    CommonModule.loadTechnologies();

    const cvr = AuthModule.user ? AuthModule.user.cvr : null;
    OrganisationModule.loadMunicipalityDetails(cvr);
  }

  setReporterId(value: boolean) {
    const reporterId = value && AuthModule.user ? AuthModule.user.uuid : null;
    this.updateFilters({ reporterId });
  }

  setUsersId(value: boolean) {
    const usersId = value && AuthModule.user ? AuthModule.user.uuid : null;
    this.updateFilters({ usersId });
  }

  setBookmarkedId(value: boolean) {
    const bookmarkedId = value && AuthModule.user ? AuthModule.user.uuid : null;
    this.updateFilters({ bookmarkedId });
  }

  setMyOrganisation(value: boolean) {
    this.updateFilters({ filterMyOrganisation: value });
  }

  setFilterOnCvr(value: boolean) {
    this.updateFilters({ filterOnCvr: value });
  }

  updateFilters(filters: Partial<SearchFilters>) {
    this.$emit('change', filters);
  }

  assignFilters(filters: Partial<SearchFilters>) {
    this.$emit('assign', filters);
  }

  onReset() {
    this.$emit('change', this.filters);
  }

  get filters() {
    return SearchModule.filters;
  }

  get municipalities() {
    return CommonModule.municipalities;
  }

  get technologies() {
    return CommonModule.technologies;
  }

  get itSystems() {
    return CommonModule.itSystems;
  }
}
